
	import { computed, defineComponent, ref } from "vue";
	import BModal from "./Modal.vue";
	import {
		NNotification,
		NotificationType,
	} from "../domain/entities/NNotification";
	import { pprint } from "@/helpers/pprint";
	import { useRouter } from "vue-router";
	import useNotification from "@/store/NotificationState";
	import HeartIcon from "@/assets/HeartIcon.vue";
	import PhoneCallIcon from "@/assets/PhoneCallIcon.vue";
	import ActivityIcon from "@/assets/ActivityIcon.vue";
	import { formatDateTime } from "@/domain/entities/EntityFields";

	export default defineComponent({
		name: "NotificationsView",
		components: {
			BModal, ActivityIcon, PhoneCallIcon, HeartIcon,
		},
		props: {},
		setup() {
			const {
				notifications : rawNotification,
				hasNewNotifications,
				listenNotifications,
				notificationsPermisionRequest,
				hasPermissionPushNotification,
				getMessagingToken,
			} = useNotification();
			listenNotifications();
			const notifications = computed(() => rawNotification.value)

			let router = useRouter();
			let toggle = ref(false);
			function onCloseClick() {
				toggle.value = false;
				// ctx.emit('on-close-click')
			}
			function open() {
				toggle.value = true;
				hasNewNotifications.value = false;
			}

			async function sendSurvey() {
				// do logic stuff here
				toggle.value = false;
			}
			function onClickNotification(notif: NNotification) {
				if (notif.type === NotificationType.VIDEO_CALL_REQUEST) {
					let code = notif.payload!["id"];
					pprint("code", code);
					router.push({
						name: "call",
						query: {
							id: code,
						},
					});
				}
			}
			
			let icon = {
				activity: require("@/assets/activity.svg"),
				heart: require("@/assets/heart.svg"),
				phoneCall: require("@/assets/phone-call.svg"),
			}
			return {
				toggle,
				onCloseClick,
				notifications,
				NotificationType,
				sendSurvey,
				open,
				onClickNotification,
				icon,
				formatDateTime,
				notificationsPermisionRequest,
				hasPermissionPushNotification,
				getMessagingToken,
			};
		},
	});
